export const iconMap = {
  '1': '',
  '11': 'wei',
  '12': 'wei',
  '121': 'wei',
  '122': 'wei',
  '123': 'wei',
  '13': '',
  '131': 'wei',
  '132': 'wei',
  '133': 'wei',
  '134': 'wei',
  '14': '',
  '141': 'wei',
  '142': 'wei',
  '143': 'wei',
  '144': 'wei',
  '145': 'wei',
  '2': '',
  '21': 'gong',
  '22': 'gong',
  '23': 'gong',
  '24': 'gong',
  '25': 'gong',
  '26': 'gong',
  '29': 'gong',
  '3': '',
  '36': 'zu',
  '39': 'zu',
  '4': 'wei',
  '41': 'wei',
  '412': 'zong',
  '5': 'wei',
  '45': 'wei',
  '521': 'wei',
  '6': '',
  '61': 'wei',
  '62': 'zong',
  '63': 'zhi',
  '64': 'zhi',
  '632': 'zhi',
  '7': '',
  '71': 'xiaozu',
  '79': 'wu',
  '9': '',
  '91': 'linwei',
  '92': 'linzong',
  '93': 'linzhi',
  '94': 'linzhi',
  'C': 'folder1'
}
export const iconTuanMap = {
  '1': 'wei',
  '11': 'wei',
  '12': 'wei',
  '121': 'wei',
  '122': 'wei',
  '123': 'wei',
  '13': '',
  '131': 'wei',
  '132': 'wei',
  '133': 'wei',
  '134': 'wei',
  '14': '',
  '141': 'wei',
  '142': 'wei',
  '143': 'wei',
  '144': 'wei',
  '145': 'wei',
  '2': '',
  '21': 'gong',
  '22': 'gong',
  '23': 'gong',
  '24': 'gong',
  '25': 'gong',
  '26': 'gong',
  '29': 'gong',
  '3': '',
  '36': 'zu',
  '39': 'zu',
  '4': 'wei',
  '41': 'wei',
  '412': 'zong',
  '5': 'wei',
  '45': 'wei',
  '521': 'wei',
  '6': '',
  '61': 'wei',
  '62': 'zong',
  '63': 'zhi',
  '7': '',
  '71': 'xiaozu',
  '799': 'wu',
  '9': '',
  '91': 'linwei',
  '92': 'linzong',
  '93': 'linzhi',
  '94': 'linzhi',
  'C': 'folder1'
}
export const iconGongMap = {
  '1': 'ji',
  '11': 'wei',
  '12': 'wei',
  '121': 'wei',
  '122': 'wei',
  '123': 'wei',
  '13': '',
  '131': 'wei',
  '132': 'wei',
  '133': 'wei',
  '134': 'wei',
  '14': '',
  '141': 'wei',
  '142': 'wei',
  '143': 'wei',
  '144': 'wei',
  '145': 'wei',
  '2': '',
  '21': 'gong',
  '22': 'gong',
  '23': 'gong',
  '24': 'gong',
  '25': 'gong',
  '26': 'gong',
  '29': 'gong',
  '3': '',
  '36': 'zu',
  '39': 'zu',
  '4': 'wei',
  '41': 'wei',
  '412': 'zong',
  '5': 'wei',
  '45': 'wei',
  '521': 'wei',
  '6': '',
  '61': 'ji',
  '62': 'gong',
  '63': 'fen',
  '64': 'zhi',
  '7': '',
  '71': 'xiaozu',
  '799': 'wu',
  '9': '',
  '91': 'linwei',
  '92': 'linzong',
  '93': 'linzhi',
  '94': 'linzhi',
  'C': 'folder1'
}